import React from 'react';
import PropTypes from 'prop-types';
import { IconAlert, IconWarning, ModalSuccess } from '~misc/icons';
import { Link } from 'react-router-dom';

import './modalResponse.scss';

const ModalResponse = ({
  isOpen,
  closeModal,
  status,
  message,
  submessage,
  button = 'Fechar',
  link = null,
  setOfflineReridect,
  idCliente,
  checkRouteRoteirizacao,
  checkin,
  testId,
}) => {
  const modalStyle = `fixed top-0 left-0 w-full h-full flex items-center justify-center z-[99999] ${
    isOpen ? '' : 'hidden'
  }`;

  const contentStyle = 'bg-white mx-4 px-20 py-10 rounded-md text-center z-[100]';

  const statusMap = {
    success: <ModalSuccess />,
    alert: <IconAlert />,
    warning: <IconWarning />,
  };

  const resolvedStatus = typeof status === 'boolean' ? (status ? 'success' : 'alert') : status;

  return (
    <div
      className={modalStyle}
      style={{ background: 'rgba(0, 0, 0, 0.5)' }}
      data-testid="modal-response"
      role="dialog"
      aria-modal="true"
    >
      <div className={contentStyle} data-testid="modal-content">
        <span className="flex justify-center mb-2" data-testid="modal-status-icon">
          {statusMap[resolvedStatus] ?? <IconAlert />}
        </span>
        <p className="font-bold text-lg block" data-testid="modal-message">
          {message}
        </p>
        <h4 className="mt-2 submessage" data-testid="modal-submessage" >
          {submessage}
        </h4>
        <span data-testid="modal-status" className="sr-only">
          {status}
        </span>

        {link !== null && !!link ? (
          <Link to={link}>
            <button
              type="button"
              className="bg-primaria hover:bg-blue-700 text-white font-bold py-2 px-4 rounded mt-8 "
              onClick={closeModal}
              data-testid="close-modal-button"
              aria-label="Fechar modal"
              data-test-id={testId}
            >
              {button}
            </button>
          </Link>
        ) : (
          <button
            type="button"
            className="bg-primaria hover:bg-blue-700 text-white font-bold py-2 px-4 rounded mt-8 "
            onClick={
              setOfflineReridect
                ? () => {
                    if (setOfflineReridect && checkin !== undefined) {
                      // checkRouteRoteirizacao(+idCliente, checkin?.clienteId);
                    }
                    closeModal();
                  }
                : closeModal
            }
            data-testid="close-modal-button"
            data-test-id={testId}
            aria-label="Fechar modal"
          >
            {button}
          </button>
        )}
      </div>
    </div>
  );
};

ModalResponse.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  status: PropTypes.oneOfType([PropTypes.oneOf(['success', 'alert', 'warning']), PropTypes.bool]).isRequired,
  message: PropTypes.string.isRequired,
  submessage: PropTypes.string,
  button: PropTypes.string,
  link: PropTypes.string,
  setOfflineReridect: PropTypes.func,
  idCliente: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  checkRouteRoteirizacao: PropTypes.func,
  checkin: PropTypes.shape({
    clienteId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }),
};

ModalResponse.defaultProps = {
  button: 'Fechar',
  link: null,
  submessage: '',
  setOfflineReridect: null,
  idCliente: null,
  checkRouteRoteirizacao: null,
  checkin: null,
};

export default ModalResponse;
